import Vue from 'vue'
import VueRouter from "vue-router";

Vue.use(VueRouter);
import HelloWorld from '@/components/HelloWorld'
import login from '@/view/login'
// import login from '@/view/LoginView.vue'
import register from '@/view/register'
import revise from "@/view/xiugai.vue"
import index from '@/view/index/index.vue'
import Navbar from '@/view/index/Navbar.vue'
import Navbars from '@/view/index/Navbars.vue'
import sNavbar from '@/view/index/sNavbar.vue'
import Notice from '@/view/index/index.vue'
import Guarantee from '@/view/Guarantee/Guarantee.vue'
import Cioand from '@/view/Guarantee/cioand.vue'
import progress from '@/view/progress/progress.vue'
import BidSecurity from '@/view/BidSecurity/BidSecurity.vue'
import financialInstitution from '@/view/BidSecurity/financialInstitution.vue'
import Submission from '@/view/BidSecurity/Submission.vue'
import bidFrom from '@/view/BidSecurity/bidFrom.vue'
import bidFroms from '@/view/BidSecurity/bidFroms.vue'
import ElectronicProtocol from '@/view/BidSecurity/ElectronicProtocol.vue'
import FanProtocol from '@/view/BidSecurity/FanProtocol.vue'
import sElectronicProtocol from '@/view/BidSecurity/sElectronicProtocol.vue'
import Public from '@/view/BidSecurity/public.vue'
import ElectronicSignature from '@/view/BidSecurity/ElectronicSignature.vue'
import Bidpayment from '@/view/BidSecurity/Bidpayment.vue'
import Bidpayments from '@/view/BidSecurity/Bidpayments.vue'
import agenciesName from '@/view/agencies/agenciesName.vue'
import userCenter from '@/view/userCenter/index.vue'
import Express from '@/view/BidSecurity/kuaidi.vue'
import Expresse from '@/view/biao/Expresse.vue'
import detail from '@/view/agencies/detail.vue'
import details from '@/view/agencies/details.vue'
import bhxq from '@/view/agencies/bhxq.vue'
import PersonalRealnames from '@/view/progress/PersonalRealname.vue'
import xinde from '@/view/biao/xin.vue'
import kuaidi from '@/view/biao/kuaidi.vue'
import xiaoxi from '@/view/index/xiaoxi.vue'
import dhdetail from '@/view/daihouguanli/detail.vue'

// Vue.use(Router)


const routes = [
  {
    path: '/',//主页
    name: 'index',
    component: index
  },
  {
    path: '/Express',//快递信息 8
    name: 'express',
    component: Express
  },
  {
    path: '/Public',//发放保函 7
    name: 'public',
    component: Public
  },
  {
    path: '/Bidpayments', //支付页面 6
    name: 'Bidpayments',
    component: Bidpayments
  },
  {
    path: '/Bidpayment', //支付 6
    name: 'Bidpayment',
    component: Bidpayment
  },
  // {
  //   path: '/Signature',//电子签章 5
  //   name: 'ElectronicSignature',
  //   component: ElectronicSignature
  // },
  // {
  //   path: '/sAgreement',//电子保函协议 5
  //   name: 'sElectronicProtocol',
  //   component: sElectronicProtocol
  // }, 
  {
    path: '/Agreement',//电子签章 5
    name: 'ElectronicProtocol',
    component: ElectronicProtocol
  }, 
  {
    path: '/Fgreement',//反担保 5
    name: 'FanProtocol',
    component: FanProtocol
  }, 
  {
    path: '/BidFroms',//投标保函 4
    name: 'bidFroms',
    component: bidFroms
  },
  {
    path: '/BidFrom',//投标保函 4
    name: 'bidFrom',
    component: bidFrom
  },
  {
    path: '/Submittals',//提交资料 3
    name: 'Submission',
    component: Submission
  },

 
  {
    path: '/Institution',//选择金融机构 2
    name: 'financialInstitution',
    component: financialInstitution
  },
  {
    path: '/SelectLot',//选择标段 1
    name: 'BidSecurity',
    component: BidSecurity
  },
  {
    path: '/kuaidi',
    name: "kuaidi",
    component: kuaidi
   
    },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/revise',
    name: 'revise',
    component: revise
  },
  {
    path: '/9',
    name: 'Guarantee',
    component: Guarantee
  },
  {
    path: '/10',
    name: 'progress',
    component: progress
  },
  {
    path: '/xiaoxi',//提交资料 3
    name: 'xiaoxi',
    component: xiaoxi
  },
  {
    path: '/cioand',
    name: 'cioand',
    component: Cioand
  },
  // 
  {
    path: '/11',
    name: 'HelloWorld',
    component: HelloWorld
  },
  {
    path: '/Notice',
    name: "/Notice",
    component: Notice
  },
  {
    path: '/Navbar',
    name: "/Navbar",
    component: Navbar
  },
  {
    path: '/xinde',
    name: "/xinde",
    component: xinde
  },
  {
    path: '/sNavbar',
    name: "/sNavbar",
    component: sNavbar
  },
  {
    path: '/Navbars',
    name: "/Navbars",
    component: Navbars
  },
  {
    path: '/zbxq',
    name: "zbxq",
    component: () => import("@/view/Guarantee/baohan/zbxq.vue"),
  },
  {
    path: '/agenciesName',
    name: "agenciesName",
    component: agenciesName
  },
  {
    path: '/userCenter',
    name: "userCenter",
    component: userCenter
  },
  {
    path: '/detail',
    name: "detail",
    component: detail
  },
  {
    path: '/details',
    name: "details",
    component: details
  },
  {
    path: '/bhxq',
    name: "bhxq",
    component: bhxq
  },
  {
    path: '/Exxpress',
    name: "Exxpress",
    component: Expresse
  },
  {
    path: '/PersonalRealnames',
    name: "PersonalRealnames",
    component: PersonalRealnames
  },
  {
    path: "/daihouguanli/detail",
    name: "daihouguanli/detail",
    component: () => import("@/view/daihouguanli/detail.vue"),
    },

]
const router = new VueRouter({
  mode:'hash',
  // mode: "history",
  routes,
});
router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem('token')
  // 如果已经登录，那我不干涉你，让你随便访问
  if (token) {
    next()
  } else {
    if (to.path !== '/login' && to.path !== '/register') {
      // 如果没有登录，但你访问其他需要登录的页面，那我就让你跳到登录页面去
      next({path: '/login'})
    } else {
      // 如果没有登录，但你访问的login，那就不干涉你，让你访问
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js